var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 5%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "xmid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在宿舍",
      "prop": "ssmc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所宿舍",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "xmid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入性别"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在楼层",
      "prop": "ssmc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所在楼层",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "年龄",
      "prop": "xmid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入年龄"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在房间",
      "prop": "ssmc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择所在房间",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "xmid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "床号",
      "prop": "ssmc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择床号",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "xmid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入住时间",
      "prop": "ssmc"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择入住时间"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "xmid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择部门",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目",
      "prop": "ssmc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择项目",
      "filterable": ""
    },
    model: {
      value: (_vm.from.xmid),
      callback: function($$v) {
        _vm.$set(_vm.from, "xmid", $$v)
      },
      expression: "from.xmid"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "20%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba9ff96","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/SsrzGl/SsrzGl_add.vue
// module id = null
// module chunks = 